import React from 'react';

import Button from '@/components/Button';

import { useFeedbackContext } from '@/features/feedbacks/contexts/FeedbackContext';
import { Container } from './styles';

const FeedbackSubmitted: React.FC = () => {
  const {
    actions: { dispatchCloseModal },
  } = useFeedbackContext();

  return (
    <Container>
      Obrigado por contribuir com o Medflow, o seu feedback é muito importante
      para nós.
      <Button theme="secondary" onClick={() => dispatchCloseModal()}>
        OK
      </Button>
    </Container>
  );
};

export default FeedbackSubmitted;
